<template lang="pug">
  .report
    PCheckbox(v-model="reportOptions.daily" label="Mostrar apontamentos por dia")
    .button
      PButton(color="success" size="md" @click="generate()" :loading="loading" :disabled="!valid") gerar arquivo

</template>

<script>
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        daily: false
      }
    }
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      const params = {
        companies: [],
        employees: [],
        employers: [],
        userGroups: [],
        year: this.reportInfo.periodData.year,
        month: this.reportInfo.periodData.month,
        ...this.reportOptions
      }

      if (this.reportInfo.entity === 'companies') {
        params.companies = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'employees') {
        params.employees = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'employer') {
        params.employers = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'userGroup') {
        params.userGroups = this.reportInfo.entityContent.map(i => i.id)
      }

      try {
        result = await this.$API.E09.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
  .report {
    display: grid;
    grid-row-gap: 10px;
    .button {
      justify-self: end;

      display: grid;
      grid-auto-flow: column;
      grid-column-gap: 10px;
    }
  }
</style>
